var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { EOrderBookType, } from "./action-interface/OrderBook";
import filter from "@domains/utils/filter";
import { EOrderBookTabs, orderBookStatus, } from "@frameworks/web/components/features/OrderBook/constant";
import { EmptyValidation } from "@domains/utils/commonText";
import { DrivingMarketMsgIcon } from "@domains/features/Markets/Equity/entities/iDrivingMarket";
var OrderBookPresenter = /** @class */ (function () {
    function OrderBookPresenter(usecase, actions) {
        this.usecase = usecase;
        this.actions = actions;
    }
    OrderBookPresenter.prototype.cancelOfsOrder = function (orderId) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.usecase.ofsCancelOrder.execute({
                onSuccess: function (data) {
                    resolve(data);
                },
                onError: function (error) {
                    reject(error);
                },
            }, orderId);
        });
    };
    OrderBookPresenter.prototype.getOfsOrderBook = function (req) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.usecase.ofsOrderBook.execute({
                onSuccess: function (data) {
                    resolve(data.data.ordLst);
                },
                onError: function (error) {
                    reject(error);
                },
            }, req);
        });
    };
    OrderBookPresenter.prototype.getMFOrderBookHoldings = function () {
        var _this = this;
        this.actions[EOrderBookType.MFH].loader(EOrderBookType.CMFH);
        this.actions[EOrderBookType.MFH].hideError(EOrderBookType.CMFH);
        this.actions[EOrderBookType.MFH].clear(EOrderBookType.CMFH);
        this.actions[EOrderBookType.MFH].loader(EOrderBookType.OMFH);
        this.actions[EOrderBookType.MFH].hideError(EOrderBookType.OMFH);
        this.actions[EOrderBookType.MFH].clear(EOrderBookType.OMFH);
        this.usecase.OrderMutualFundsHoldings.execute({
            onSuccess: function (data) {
                var openORBook = filter(data.ordLst, 
                // mfOrderBookStatus[EOrderBookTabs.OPENORDER]?.map((m) => {
                //   return { key: "status", value: m };
                // })
                [{ key: "status", value: "ON HOLD" }]);
                var closeOrderBook = filter(data.ordLst, 
                // mfOrderBookStatus[EOrderBookTabs.CLOSEORDER]?.map((m) => {
                //   return { key: "status", value: m };
                // })
                [{ key: "status", value: "ON HOLD" }]);
                if (openORBook.length === 0) {
                    _this.actions[EOrderBookType.MFH].addMsg(EmptyValidation.default, true, DrivingMarketMsgIcon.DEFAULT, EOrderBookType.OMFH);
                }
                if (closeOrderBook.length === 0) {
                    _this.actions[EOrderBookType.MFH].addMsg(EmptyValidation.default, true, DrivingMarketMsgIcon.DEFAULT, EOrderBookType.CMFH);
                }
                _this.actions[EOrderBookType.MFH].getMFOrderBookHoldingsData(__assign(__assign({}, data), { ordLst: closeOrderBook }), EOrderBookType.CMFH);
                _this.actions[EOrderBookType.MFH].stopLoader(EOrderBookType.CMFH);
                _this.actions[EOrderBookType.MFH].getMFOrderBookHoldingsData(__assign(__assign({}, data), { ordLst: openORBook }), EOrderBookType.OMFH);
                _this.actions[EOrderBookType.MFH].stopLoader(EOrderBookType.OMFH);
            },
            onError: function (error) {
                _this.actions[EOrderBookType.MFH].setError({
                    error: error,
                    isOpen: true,
                }, EOrderBookType.CMFH);
                _this.actions[EOrderBookType.MFH].stopLoader(EOrderBookType.CMFH);
                _this.actions[EOrderBookType.MFH].setError({
                    error: error,
                    isOpen: true,
                }, EOrderBookType.OMFH);
                _this.actions[EOrderBookType.MFH].stopLoader(EOrderBookType.OMFH);
            },
        }, null);
    };
    OrderBookPresenter.prototype.cancelNfoOrder = function (req) {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                return [2 /*return*/, new Promise(function (resolve, reject) {
                        _this.usecase.nfoOrderCancel.execute({
                            onSuccess: function (data) {
                                resolve(data);
                            },
                            onError: function (error) {
                                reject(error);
                            },
                        }, req);
                    })];
            });
        });
    };
    OrderBookPresenter.prototype.snapQoute = function (req) {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                return [2 /*return*/, new Promise(function (resolve, reject) {
                        _this.usecase.snapQuote.execute({
                            onSuccess: function (data) {
                                resolve(data);
                            },
                            onError: function (error) {
                                reject(error);
                            },
                        }, req);
                    })];
            });
        });
    };
    OrderBookPresenter.prototype.cancelMfOrder = function (req) {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                return [2 /*return*/, new Promise(function (resolve, reject) {
                        _this.usecase.mfOrderCancel.execute({
                            onSuccess: function (data) {
                                resolve(data);
                            },
                            onError: function (error) {
                                reject(error);
                            },
                        }, req);
                    })];
            });
        });
    };
    OrderBookPresenter.prototype.getMFSipChildOrderBook = function (req) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.usecase.mfSipChild.execute({
                onSuccess: function (data) {
                    resolve(data);
                },
                onError: function (error) {
                    reject(error);
                },
            }, req);
        });
    };
    OrderBookPresenter.prototype.addMsg = function (message, type, baseType) {
        this.actions[baseType].addMsg(message.msg, message.show, message.icon, type);
    };
    OrderBookPresenter.prototype.getCoOrderBook = function () {
        var _this = this;
        this.actions[EOrderBookType.CO].loader(EOrderBookType.OCO);
        this.actions[EOrderBookType.CO].hideError(EOrderBookType.OCO);
        this.actions[EOrderBookType.CO].clear(EOrderBookType.OCO);
        this.actions[EOrderBookType.CO].loader(EOrderBookType.CCO);
        this.actions[EOrderBookType.CO].hideError(EOrderBookType.CCO);
        this.actions[EOrderBookType.CO].clear(EOrderBookType.CCO);
        this.usecase.OrderCommodity.execute({
            onSuccess: function (data) {
                // const openORBook = filter(
                //   data.data.ord,
                //   orderBookStatus[EOrderBookTabs.OPENORDER]?.map((m) => {
                //     return { key: "sts", value: m };
                //   })
                // );
                var _a, _b;
                var closeOrderBook = filter(data.data.ord, (_a = orderBookStatus[EOrderBookTabs.CLOSEORDER]) === null || _a === void 0 ? void 0 : _a.map(function (m) {
                    return { key: "sts", value: m };
                }));
                var openORBook = filter(data.data.ord, (_b = data.data.ord) === null || _b === void 0 ? void 0 : _b.filter(function (x) {
                    return !orderBookStatus[EOrderBookTabs.CLOSEORDER].includes(x.sts);
                }).map(function (y) {
                    return { key: "sts", value: y.sts };
                }));
                if (openORBook.length === 0) {
                    _this.actions[EOrderBookType.CO].addMsg(EmptyValidation.default, true, DrivingMarketMsgIcon.DEFAULT, EOrderBookType.OCO);
                }
                if (closeOrderBook.length === 0) {
                    _this.actions[EOrderBookType.CO].addMsg(EmptyValidation.default, true, DrivingMarketMsgIcon.DEFAULT, EOrderBookType.CCO);
                }
                _this.actions[EOrderBookType.CO].getOrderBookData(__assign(__assign({}, data.data), { ord: closeOrderBook }), EOrderBookType.CCO);
                _this.actions[EOrderBookType.CO].stopLoader(EOrderBookType.CCO);
                _this.actions[EOrderBookType.CO].getOrderBookData(__assign(__assign({}, data.data), { ord: openORBook }), EOrderBookType.OCO);
                _this.actions[EOrderBookType.CO].stopLoader(EOrderBookType.OCO);
            },
            onError: function (error) {
                _this.actions[EOrderBookType.CO].setError({
                    error: error,
                    isOpen: true,
                }, EOrderBookType.CCO);
                _this.actions[EOrderBookType.CO].stopLoader(EOrderBookType.CCO);
                _this.actions[EOrderBookType.CO].setError({
                    error: error,
                    isOpen: true,
                }, EOrderBookType.OCO);
                _this.actions[EOrderBookType.CO].stopLoader(EOrderBookType.OCO);
            },
        }, null);
    };
    OrderBookPresenter.prototype.getEqOrderBook = function () {
        var _this = this;
        this.actions[EOrderBookType.EQ].loader(EOrderBookType.OEQ);
        this.actions[EOrderBookType.EQ].hideError(EOrderBookType.OEQ);
        this.actions[EOrderBookType.EQ].clear(EOrderBookType.OEQ);
        this.actions[EOrderBookType.EQ].loader(EOrderBookType.CEQ);
        this.actions[EOrderBookType.EQ].hideError(EOrderBookType.CEQ);
        this.actions[EOrderBookType.EQ].clear(EOrderBookType.CEQ);
        this.usecase.OrderEquity.execute({
            onSuccess: function (data) {
                var _a, _b;
                var openORBook = filter(data.data.ord, (_a = data.data.ord) === null || _a === void 0 ? void 0 : _a.filter(function (x) {
                    return !orderBookStatus[EOrderBookTabs.CLOSEORDER].includes(x.sts);
                }).map(function (y) {
                    return { key: "sts", value: y.sts };
                }));
                var closeOrderBook = filter(data.data.ord, (_b = orderBookStatus[EOrderBookTabs.CLOSEORDER]) === null || _b === void 0 ? void 0 : _b.map(function (m) {
                    return { key: "sts", value: m };
                }));
                if (openORBook.length === 0) {
                    _this.actions[EOrderBookType.EQ].addMsg(EmptyValidation.noOpenOrder, true, DrivingMarketMsgIcon.DEFAULT, EOrderBookType.OEQ);
                }
                if (closeOrderBook.length === 0) {
                    _this.actions[EOrderBookType.EQ].addMsg(EmptyValidation.noClosedOrder, true, DrivingMarketMsgIcon.DEFAULT, EOrderBookType.CEQ);
                }
                _this.actions[EOrderBookType.EQ].getOrderBookData(__assign(__assign({}, data.data), { ord: closeOrderBook }), EOrderBookType.CEQ);
                _this.actions[EOrderBookType.EQ].stopLoader(EOrderBookType.CEQ);
                _this.actions[EOrderBookType.EQ].getOrderBookData(__assign(__assign({}, data.data), { ord: openORBook }), EOrderBookType.OEQ);
                _this.actions[EOrderBookType.EQ].stopLoader(EOrderBookType.OEQ);
            },
            onError: function (error) {
                _this.actions[EOrderBookType.EQ].setError({
                    error: error,
                    isOpen: true,
                }, EOrderBookType.CEQ);
                _this.actions[EOrderBookType.EQ].stopLoader(EOrderBookType.CEQ);
                _this.actions[EOrderBookType.EQ].setError({
                    error: error,
                    isOpen: true,
                }, EOrderBookType.OEQ);
                _this.actions[EOrderBookType.EQ].stopLoader(EOrderBookType.OEQ);
            },
        }, null);
    };
    OrderBookPresenter.prototype.getMFOrderBook = function () {
        var _this = this;
        this.actions[EOrderBookType.MF].loader(EOrderBookType.MF);
        this.actions[EOrderBookType.MF].hideError(EOrderBookType.MF);
        this.actions[EOrderBookType.MF].clear(EOrderBookType.MF);
        this.usecase.OrderMutualFunds.execute({
            onSuccess: function (data) {
                if (data.data.ordLst.length === 0) {
                    _this.actions[EOrderBookType.MF].addMsg(EmptyValidation.default, true, DrivingMarketMsgIcon.DEFAULT, EOrderBookType.MF);
                }
                _this.actions[EOrderBookType.MF].getMFOrderBookData(__assign(__assign({}, data.data), { ordLst: data.data.ordLst }), EOrderBookType.MF);
                _this.actions[EOrderBookType.MF].stopLoader(EOrderBookType.MF);
            },
            onError: function (error) {
                _this.actions[EOrderBookType.MF].setError({
                    error: error,
                    isOpen: true,
                }, EOrderBookType.MF);
                _this.actions[EOrderBookType.MF].stopLoader(EOrderBookType.MF);
            },
        }, null);
    };
    OrderBookPresenter.prototype.getNFOOrderBook = function () {
        var _this = this;
        this.actions[EOrderBookType.NFO].loader(EOrderBookType.NFO);
        this.actions[EOrderBookType.NFO].hideError(EOrderBookType.NFO);
        this.actions[EOrderBookType.NFO].clear(EOrderBookType.NFO);
        this.usecase.OrderNewFundOrder.execute({
            onSuccess: function (data) {
                if (data.data.ordLst.length === 0) {
                    _this.actions[EOrderBookType.NFO].addMsg(EmptyValidation.default, true, DrivingMarketMsgIcon.DEFAULT, EOrderBookType.NFO);
                }
                _this.actions[EOrderBookType.NFO].getNFOOrderBookData(__assign(__assign({}, data.data), { ordLst: data.data.ordLst }), EOrderBookType.NFO);
                _this.actions[EOrderBookType.NFO].stopLoader(EOrderBookType.NFO);
            },
            onError: function (error) {
                _this.actions[EOrderBookType.NFO].setError({
                    error: error,
                    isOpen: true,
                }, EOrderBookType.NFO);
                _this.actions[EOrderBookType.NFO].stopLoader(EOrderBookType.NFO);
            },
        }, null);
    };
    OrderBookPresenter.prototype.getEqSipOrderBook = function () {
        var _this = this;
        this.actions[EOrderBookType.EQSIP].loader(EOrderBookType.EQSIP);
        this.actions[EOrderBookType.EQSIP].hideError(EOrderBookType.EQSIP);
        this.actions[EOrderBookType.EQSIP].clear(EOrderBookType.EQSIP);
        this.usecase.EQSIP.execute({
            onSuccess: function (data) {
                if (data.data.resLst.length === 0) {
                    _this.actions[EOrderBookType.EQSIP].addMsg(EmptyValidation.noSipOrder, true, DrivingMarketMsgIcon.DEFAULT, EOrderBookType.EQSIP);
                }
                else {
                    _this.actions[EOrderBookType.EQSIP].addMsg("", false, DrivingMarketMsgIcon.DEFAULT, EOrderBookType.EQSIP);
                }
                _this.actions[EOrderBookType.EQSIP].getEqSipOrderBookData(data.data, EOrderBookType.EQSIP);
                _this.actions[EOrderBookType.EQSIP].stopLoader(EOrderBookType.EQSIP);
            },
            onError: function (error) {
                if ((error === null || error === void 0 ? void 0 : error.getHttpCode()) == 222) {
                    _this.actions[EOrderBookType.EQSIP].addMsg(EmptyValidation.noSipOrder, true, DrivingMarketMsgIcon.DEFAULT, EOrderBookType.EQSIP);
                }
                else {
                    _this.actions[EOrderBookType.EQSIP].setError({
                        error: error,
                        isOpen: true,
                    }, EOrderBookType.EQSIP);
                }
                _this.actions[EOrderBookType.EQSIP].stopLoader(EOrderBookType.EQSIP);
            },
        }, null);
    };
    OrderBookPresenter.prototype.getMFSipOrderBook = function () {
        var _this = this;
        this.actions[EOrderBookType.MFSIP].loader(EOrderBookType.MFSIP);
        this.actions[EOrderBookType.MFSIP].hideError(EOrderBookType.MFSIP);
        this.actions[EOrderBookType.MFSIP].clear(EOrderBookType.MFSIP);
        this.usecase.MFSIP.execute({
            onSuccess: function (data) {
                if (data.data.sipOrdLst.length === 0) {
                    _this.actions[EOrderBookType.MFSIP].addMsg(EmptyValidation.default, true, DrivingMarketMsgIcon.DEFAULT, EOrderBookType.MFSIP);
                }
                _this.actions[EOrderBookType.MFSIP].getMFSipOrderBookData(data.data, EOrderBookType.MFSIP);
                _this.actions.MFSIP.stopLoader(EOrderBookType.MFSIP);
            },
            onError: function (error) {
                _this.actions[EOrderBookType.MFSIP].setError({
                    error: error,
                    isOpen: true,
                }, EOrderBookType.MFSIP);
                _this.actions[EOrderBookType.MFSIP].stopLoader(EOrderBookType.MFSIP);
            },
        }, null);
    };
    OrderBookPresenter.prototype.flushOrderBookErrorData = function () {
        this.actions[EOrderBookType.IPO].setError({
            error: null,
            isOpen: false,
        }, EOrderBookType.IPO);
    };
    OrderBookPresenter.prototype.getIPOOrderBook = function (req) {
        var _this = this;
        this.actions[EOrderBookType.IPO].loader(EOrderBookType.IPO);
        this.actions[EOrderBookType.IPO].hideError(EOrderBookType.IPO);
        this.actions[EOrderBookType.IPO].clear(EOrderBookType.IPO);
        this.usecase.IPO.execute({
            onSuccess: function (data) {
                if (data.data.ordLst.length === 0) {
                    _this.actions[EOrderBookType.IPO].addMsg(EmptyValidation.noIpoOrder, true, DrivingMarketMsgIcon.DEFAULT, EOrderBookType.IPO);
                }
                _this.actions[EOrderBookType.IPO].getIPOOrderBookData(__assign(__assign({}, data.data), { ordLst: data.data.ordLst }), EOrderBookType.IPO);
                _this.actions[EOrderBookType.IPO].stopLoader(EOrderBookType.IPO);
            },
            onError: function (error) {
                if ((error === null || error === void 0 ? void 0 : error.getHttpCode()) == 222) {
                    _this.actions[EOrderBookType.IPO].addMsg(EmptyValidation.noIpoOrder, true, DrivingMarketMsgIcon.DEFAULT, EOrderBookType.IPO);
                }
                else {
                    _this.actions[EOrderBookType.IPO].setError({
                        error: error,
                        isOpen: true,
                    }, EOrderBookType.IPO);
                }
                _this.actions[EOrderBookType.IPO].stopLoader(EOrderBookType.IPO);
            },
        }, req);
    };
    OrderBookPresenter.prototype.getNcdIPOOrderBook = function (req) {
        var _this = this;
        this.actions[EOrderBookType.NCDIPO].loader(EOrderBookType.NCDIPO);
        this.actions[EOrderBookType.NCDIPO].hideError(EOrderBookType.NCDIPO);
        this.actions[EOrderBookType.NCDIPO].clear(EOrderBookType.NCDIPO);
        this.usecase.IPO.execute({
            onSuccess: function (data) {
                if (data.data.ordLst.length === 0) {
                    _this.actions[EOrderBookType.NCDIPO].addMsg(EmptyValidation.noNcdOrder, true, DrivingMarketMsgIcon.DEFAULT, EOrderBookType.NCDIPO);
                }
                _this.actions[EOrderBookType.NCDIPO].getNCDIPOOrderBookData(__assign(__assign({}, data.data), { ordLst: data.data.ordLst }), EOrderBookType.NCDIPO);
                _this.actions[EOrderBookType.NCDIPO].stopLoader(EOrderBookType.NCDIPO);
            },
            onError: function (error) {
                if ((error === null || error === void 0 ? void 0 : error.getHttpCode()) == 222) {
                    _this.actions[EOrderBookType.NCDIPO].addMsg(EmptyValidation.noNcdOrder, true, DrivingMarketMsgIcon.DEFAULT, EOrderBookType.NCDIPO);
                }
                else {
                    _this.actions[EOrderBookType.NCDIPO].setError({
                        error: error,
                        isOpen: true,
                    }, EOrderBookType.NCDIPO);
                }
                _this.actions[EOrderBookType.NCDIPO].stopLoader(EOrderBookType.NCDIPO);
            },
        }, req);
    };
    return OrderBookPresenter;
}());
export default OrderBookPresenter;
